"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedClientEx = void 0;
var utils_1 = require("./utils");
var EmbedConnection_1 = require("./EmbedConnection");
var EmbedClientEx = /** @class */ (function () {
    /**
     * @hidden
     */
    function EmbedClientEx(_sdk, _builder) {
        this._sdk = _sdk;
        this._builder = _builder;
        this._cookielessInitialized = false;
        this._cookielessSessionExpired = false;
        this._hasSessionExpired = false;
    }
    Object.defineProperty(EmbedClientEx.prototype, "connection", {
        /**
         * Returns a promise that resolves to a client that can be used to send messages to the
         * embedded content.
         */
        get: function () {
            return this._connection;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedClientEx.prototype, "isConnected", {
        /**
         * Indicates whether two way communication has successfully been established with the embedded content.
         */
        get: function () {
            return !!this._connection;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedClientEx.prototype, "targetOrigin", {
        /**
         * Target origin for messages
         */
        get: function () {
            if (this._builder.sandboxedHost) {
                return '*';
            }
            var apiHost = this._builder.apiHost;
            return utils_1.IS_URL.test(apiHost) ? apiHost : "https://".concat(apiHost);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedClientEx.prototype, "isPageLoadEventSupported", {
        /**
         * Indicates in the page:load event is supported by the version of Looker being embedded
         */
        get: function () {
            return this._lookerVersion !== undefined && this._lookerVersion >= 25.1;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Establish two way communication with embedded content. Returns a promise that resolves to a
     * client that can be used to send messages to the embedded content.
     */
    EmbedClientEx.prototype.connect = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.connectInternal(options).then(function (connection) {
                        _this._connection = connection;
                        return connection;
                    })];
            });
        });
    };
    EmbedClientEx.prototype.appendRequiredParameters = function (urlString) {
        var requiredParams;
        if (this._builder.sandboxedHost) {
            // Sandboxed host is set when the origin is null which is the legacy
            // extension framework loader. Typically, the extension framework
            // prefixes the apiHost with 'https://'. This is incorrect but it
            // works as the extension framework private embeds. Anyway, handle it
            // being there or not.
            var prefix = this._sdk.apiHost.startsWith('https://') ? '' : 'https://';
            requiredParams = {
                embed_domain: "".concat(prefix).concat(this._sdk.apiHost),
                sandboxed_host: 'true',
                sdk: '3',
            };
        }
        else {
            var embedDomain = window.location.origin;
            requiredParams = {
                embed_domain: embedDomain,
                sdk: '3',
            };
        }
        if (this._builder.allowLoginScreen && !this._builder.sandboxedHost) {
            requiredParams.allow_login_screen = 'true';
        }
        var tempOrigin = urlString.startsWith('https://') ? '' : 'http://abc';
        var url = new URL("".concat(tempOrigin).concat(urlString));
        var replaceEmbedDomain = !url.searchParams.has('embed_domain');
        for (var key in requiredParams) {
            if (!url.searchParams.has(key)) {
                url.searchParams.append(key, requiredParams[key]);
            }
        }
        var embedString = url.toString();
        // For backwards compatibility unencode embed domain
        if (replaceEmbedDomain) {
            embedString = embedString.replace("embed_domain=".concat(encodeURIComponent(requiredParams.embed_domain)), "embed_domain=".concat(requiredParams.embed_domain));
        }
        if (tempOrigin) {
            embedString = embedString.replace('http://abc', '');
        }
        return embedString;
    };
    EmbedClientEx.prototype.connectInternal = function (options) {
        var _a;
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                if (this._connectionPromise)
                    return [2 /*return*/, this._connectionPromise];
                if (!((_a = this._builder.auth) === null || _a === void 0 ? void 0 : _a.url) && !this._builder.isCookielessEmbed) {
                    // Private embedding
                    this._connectionPromise = this.abortableCreateIframe(this.prependApiHost(this.appendRequiredParameters(this._builder.embedUrl)), options);
                }
                else {
                    if (this._builder.isCookielessEmbed) {
                        // Cookieless embedding
                        this._connectionPromise = this.acquireCookielessEmbedSession(options)
                            .then(function (url) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2 /*return*/, this.abortableCreateIframe(url, options)];
                        }); }); })
                            .catch(function (_error) {
                            _this._connectionPromise = undefined;
                            throw _error;
                        });
                    }
                    else {
                        // Signed
                        this._connectionPromise = this.abortableCreateSignedUrl(options).then(function (url) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2 /*return*/, this.abortableCreateIframe(url, options)];
                        }); }); });
                    }
                }
                return [2 /*return*/, this._connectionPromise];
            });
        });
    };
    EmbedClientEx.prototype.prependApiHost = function (url) {
        return "https://".concat(this._sdk.apiHost).concat(url);
    };
    EmbedClientEx.prototype.updateEditing = function (isEditing) {
        if (this._connection) {
            this._connection._isEditing = isEditing;
        }
    };
    EmbedClientEx.prototype.abortableCreateIframe = function (url, _a) {
        var waitUntilLoaded = _a.waitUntilLoaded, signal = _a.signal;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var promiseAborted = false;
                        var abortHandler = function () {
                            _this._sdk._createEmbedSessionPromise = undefined;
                            promiseAborted = true;
                            reject(signal === null || signal === void 0 ? void 0 : signal.reason);
                        };
                        if (waitUntilLoaded && signal) {
                            signal.addEventListener('abort', abortHandler);
                        }
                        _this.createIframe(url, waitUntilLoaded)
                            .then(function (connection) {
                            signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', abortHandler);
                            if (!promiseAborted) {
                                _this._sdk._sessionCreated = true;
                                resolve(connection);
                            }
                        })
                            .catch(function (error) {
                            signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', abortHandler);
                            if (!promiseAborted) {
                                _this._sdk._createEmbedSessionPromise = undefined;
                                reject(error);
                            }
                        });
                    })];
            });
        });
    };
    EmbedClientEx.prototype.createIframe = function (url, waitUntilLoaded) {
        return __awaiter(this, void 0, void 0, function () {
            var eventType, _loop_1, this_1, _i, _a, handler, _b, _c, attr, _d, _e, attr, connectPromise;
            var _f;
            var _this = this;
            return __generator(this, function (_g) {
                this._hostBuilder = this._sdk.chattyHostCreator(url);
                if (!this._builder.handlers['session:expired']) {
                    this._builder.handlers['session:expired'] = [];
                }
                this._builder.handlers['session:expired'].push(function () {
                    _this._hasSessionExpired = true;
                    _this._sdk.clearSession();
                });
                if (!this._builder.handlers['page:changed']) {
                    this._builder.handlers['page:changed'] = [];
                }
                this._builder.handlers['page:changed'].push(function (event) {
                    var _a, _b;
                    if (_this._connection) {
                        var pathname = (((_a = event === null || event === void 0 ? void 0 : event.page) === null || _a === void 0 ? void 0 : _a.url) || '').split('?')[0];
                        if (pathname !== _this._connection._currentPathname) {
                            _this._connection._currentPathname = pathname;
                            if (_this._connection.isEditing()) {
                                _this.updateEditing(false);
                            }
                            _this.identifyPageType(event);
                        }
                    }
                    _this.parseLookerVersion((_b = event === null || event === void 0 ? void 0 : event.page) === null || _b === void 0 ? void 0 : _b.lookerVersion);
                    if (_this._pageChangeResolver) {
                        var resolve = _this._pageChangeResolver;
                        _this._pageChangeResolver = undefined;
                        resolve(_this._client);
                    }
                });
                if (!this._builder.handlers['dashboard:edit:start']) {
                    this._builder.handlers['dashboard:edit:start'] = [];
                }
                this._builder.handlers['dashboard:edit:start'].push(function () {
                    return _this.updateEditing(true);
                });
                if (!this._builder.handlers['dashboard:edit:cancel']) {
                    this._builder.handlers['dashboard:edit:cancel'] = [];
                }
                this._builder.handlers['dashboard:edit:cancel'].push(function () {
                    return _this.updateEditing(false);
                });
                if (!this._builder.handlers['dashboard:save:complete']) {
                    this._builder.handlers['dashboard:save:complete'] = [];
                }
                this._builder.handlers['dashboard:save:complete'].push(function () {
                    return _this.updateEditing(false);
                });
                if (!this._builder.handlers['look:edit:start']) {
                    this._builder.handlers['look:edit:start'] = [];
                }
                this._builder.handlers['look:edit:start'].push(function () {
                    return _this.updateEditing(true);
                });
                if (!this._builder.handlers['look:edit:cancel']) {
                    this._builder.handlers['look:edit:cancel'] = [];
                }
                this._builder.handlers['look:edit:cancel'].push(function () {
                    return _this.updateEditing(false);
                });
                if (!this._builder.handlers['look:save:complete']) {
                    this._builder.handlers['look:save:complete'] = [];
                }
                this._builder.handlers['look:save:complete'].push(function () {
                    return _this.updateEditing(false);
                });
                if (this._builder.dialogScroll) {
                    if (!this._builder.handlers['env:client:dialog']) {
                        this._builder.handlers['env:client:dialog'] = [];
                    }
                    this._builder.handlers['env:client:dialog'].push(function (_a) {
                        var open = _a.open, placement = _a.placement;
                        // Placement of 'cover' means that the dialog top is close
                        // to the top of the IFRAME. The top MAY be scrolled out
                        // of view. The following attempts to scroll the top of the
                        // dialog into view.
                        if (open && placement === 'cover') {
                            // Timeout is a little ugly. Suspect there might be an issue
                            // with a Looker component where the last row is scrolled
                            // into view. Normally not an issue because outside of embed
                            // as the dialog is limited to the viewport.
                            // Make timeout configurable?
                            window.setTimeout(function () {
                                if (_this._host) {
                                    _this._host.iframe.scrollIntoView(true);
                                }
                            }, 200);
                        }
                    });
                }
                if (this._builder.dynamicIFrameHeight) {
                    if (!this._builder.handlers['page:properties:changed']) {
                        this._builder.handlers['page:properties:changed'] = [];
                    }
                    this._builder.handlers['page:properties:changed'].push(function (_a) {
                        var height = _a.height;
                        if (height && height > 100 && _this._host) {
                            _this._host.iframe.style.height = "".concat(height, "px");
                        }
                    });
                }
                if (this._builder.isCookielessEmbed) {
                    if (!this._builder.handlers['session:status']) {
                        this._builder.handlers['session:status'] = [];
                    }
                    this._builder.handlers['session:status'].push(function (event) {
                        if (event === null || event === void 0 ? void 0 : event.expired) {
                            _this._cookielessSessionExpired = true;
                        }
                    });
                    if (!this._builder.handlers['session:tokens:request']) {
                        this._builder.handlers['session:tokens:request'] = [];
                    }
                    this._builder.handlers['session:tokens:request'].push(function () { return __awaiter(_this, void 0, void 0, function () {
                        var cookielessSession, updateGenerateTokensTime, _a, api_token, api_token_ttl, navigation_token, navigation_token_ttl, session_reference_token_ttl, error_1, newGenerateTokensTime, cookielessSessionReferenceTokenTtl, cookielessApiTokenTtl, cookielessNavigationTokenTtl, ttl;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    cookielessSession = this._sdk._cookielessSession;
                                    // Make typescript happy. This should not happen
                                    if (!cookielessSession || !this._client) {
                                        throw new Error('Invalid state');
                                    }
                                    updateGenerateTokensTime = cookielessSession.generateTokensTime === 0;
                                    if (!!this._cookielessSessionExpired) return [3 /*break*/, 6];
                                    if (!this._cookielessInitialized) return [3 /*break*/, 5];
                                    if (!(Date.now() > cookielessSession.generateTokensTime)) return [3 /*break*/, 4];
                                    updateGenerateTokensTime = true;
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, this.generateTokens()];
                                case 2:
                                    _a = _b.sent(), api_token = _a.api_token, api_token_ttl = _a.api_token_ttl, navigation_token = _a.navigation_token, navigation_token_ttl = _a.navigation_token_ttl, session_reference_token_ttl = _a.session_reference_token_ttl;
                                    if (session_reference_token_ttl === 0 ||
                                        (api_token &&
                                            Number(api_token_ttl) > 0 &&
                                            navigation_token &&
                                            Number(navigation_token_ttl) > 0 &&
                                            typeof session_reference_token_ttl === 'number')) {
                                        // Valid looking tokens
                                        cookielessSession.cookielessApiToken = api_token;
                                        cookielessSession.cookielessApiTokenTtl = api_token_ttl;
                                        cookielessSession.cookielessNavigationToken = navigation_token;
                                        cookielessSession.cookielessNavigationTokenTtl =
                                            navigation_token_ttl;
                                        cookielessSession.cookielessSessionReferenceTokenTtl =
                                            session_reference_token_ttl;
                                    }
                                    else {
                                        // cookielessSessionReferenceTokenTtl of null means we did not
                                        // get valid tokens
                                        cookielessSession.cookielessSessionReferenceTokenTtl = null;
                                    }
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _b.sent();
                                    // cookielessSessionReferenceTokenTtl of null means we did not
                                    // get valid tokens
                                    cookielessSession.cookielessSessionReferenceTokenTtl = null;
                                    return [3 /*break*/, 4];
                                case 4: return [3 /*break*/, 6];
                                case 5:
                                    // Perhaps mark as initialized. If cookielessSessionReferenceTokenTtl is
                                    // not a mumber the acquire session failed.
                                    this._cookielessInitialized =
                                        !!cookielessSession.cookielessSessionReferenceTokenTtl;
                                    _b.label = 6;
                                case 6:
                                    // We did not get valid tokens. Looker will display interrupted screen
                                    if (typeof cookielessSession.cookielessSessionReferenceTokenTtl !==
                                        'number') {
                                        this._client.send('session:tokens', {
                                            api_token: undefined,
                                            api_token_ttl: undefined,
                                            navigation_token: undefined,
                                            navigation_token_ttl: undefined,
                                            session_reference_token_ttl: undefined,
                                        });
                                        return [2 /*return*/];
                                    }
                                    // Session has expired. Need to send valid tokens for backwards
                                    // compatibility
                                    if (cookielessSession.cookielessSessionReferenceTokenTtl === 0) {
                                        this._client.send('session:tokens', {
                                            api_token: 'session expired',
                                            api_token_ttl: 240,
                                            navigation_token: 'session expired',
                                            navigation_token_ttl: 240,
                                            session_reference_token_ttl: 0,
                                        });
                                        return [2 /*return*/];
                                    }
                                    if (updateGenerateTokensTime) {
                                        // At this point we have valid tokens. Use the same tokens until
                                        // 2 minutes before expiry time. This prevents multiple IFRAMEs
                                        // from hammering the generate token endpoint
                                        if (cookielessSession.cookielessSessionReferenceTokenTtl === 0) {
                                            this._cookielessSessionExpired = true;
                                            cookielessSession.generateTokensTime = 0;
                                        }
                                        else {
                                            newGenerateTokensTime = Date.now();
                                            cookielessSessionReferenceTokenTtl = cookielessSession.cookielessSessionReferenceTokenTtl, cookielessApiTokenTtl = cookielessSession.cookielessApiTokenTtl, cookielessNavigationTokenTtl = cookielessSession.cookielessNavigationTokenTtl;
                                            ttl = Math.min(cookielessSessionReferenceTokenTtl, Number(cookielessApiTokenTtl), Number(cookielessNavigationTokenTtl));
                                            if (ttl < 60) {
                                                newGenerateTokensTime = Date.now();
                                            }
                                            else if (ttl < 120) {
                                                newGenerateTokensTime = Date.now() + 60 * 1000;
                                            }
                                            else {
                                                newGenerateTokensTime = Date.now() + (ttl - 120) * 1000;
                                            }
                                            cookielessSession.generateTokensTime = newGenerateTokensTime;
                                        }
                                    }
                                    // Send good tokens
                                    this._client.send('session:tokens', {
                                        api_token: cookielessSession.cookielessApiToken,
                                        api_token_ttl: cookielessSession.cookielessApiTokenTtl,
                                        navigation_token: cookielessSession.cookielessNavigationToken,
                                        navigation_token_ttl: cookielessSession.cookielessNavigationTokenTtl,
                                        session_reference_token_ttl: cookielessSession.cookielessSessionReferenceTokenTtl,
                                    });
                                    // Clear the generateTokensPromise. All IFRAMEs will queue up
                                    // on the same promise
                                    this._sdk._generateTokensPromise = undefined;
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                }
                for (eventType in this._builder.handlers) {
                    _loop_1 = function (handler) {
                        this_1._hostBuilder.on(eventType, function () {
                            var args = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                args[_i] = arguments[_i];
                            }
                            return handler.apply(_this._client, args);
                        });
                    };
                    this_1 = this;
                    for (_i = 0, _a = this._builder.handlers[eventType]; _i < _a.length; _i++) {
                        handler = _a[_i];
                        _loop_1(handler);
                    }
                }
                for (_b = 0, _c = this._builder.sandboxAttrs; _b < _c.length; _b++) {
                    attr = _c[_b];
                    this._hostBuilder.withSandboxAttribute(attr);
                }
                for (_d = 0, _e = this._builder.allowAttrs; _d < _e.length; _d++) {
                    attr = _e[_d];
                    this._hostBuilder.withAllowAttribute(attr);
                }
                this._host = this._hostBuilder
                    // tslint:disable-next-line:deprecation
                    .frameBorder(this._builder.frameBorder)
                    .withTargetOrigin(this.targetOrigin)
                    .withAriaLabel(this._builder.ariaLabel)
                    .appendTo(this._builder.el)
                    .build();
                // IE doesn't like calling classList.add() with no arguments, so check
                if (this._builder.classNames.length) {
                    (_f = this._host.iframe.classList).add.apply(_f, this._builder.classNames);
                }
                if (this._builder.scrollMonitor) {
                    this.addIframeMonitor(this._host.iframe);
                }
                connectPromise = this._host.connect().then(function (host) {
                    _this._client = new EmbedConnection_1.EmbedConnection(host, _this);
                    if (_this._sdk._createEmbedSessionPromiseResolver) {
                        // Resolve the create session promise now that the IFRAME
                        // has been loaded.
                        _this._sdk._sessionCreated = true;
                        var resolver = _this._sdk._createEmbedSessionPromiseResolver;
                        _this._sdk._createEmbedSessionPromiseResolver = undefined;
                        // An empty string is used because the same resolver is
                        // used for cookieless which does return a url. Signed url
                        // will use the bare url which is available to the promise
                        // resolution listener.
                        resolver('');
                    }
                    return _this._client;
                });
                if (waitUntilLoaded) {
                    return [2 /*return*/, new Promise(function (resolve) {
                            _this._pageChangeResolver = resolve;
                        })];
                }
                return [2 /*return*/, connectPromise];
            });
        });
    };
    EmbedClientEx.prototype.sendScrollData = function (iframe) {
        if (this._client) {
            this._client.send('env:host:scroll', {
                offsetLeft: iframe.offsetLeft,
                offsetTop: iframe.offsetTop,
                scrollX: window.scrollX,
                scrollY: window.scrollY,
            });
        }
    };
    EmbedClientEx.prototype.addIframeMonitor = function (iframe) {
        var _this = this;
        document.addEventListener('scroll', function (_event) {
            _this.sendScrollData(iframe);
        });
        window.addEventListener('resize', function (_event) {
            _this.sendScrollData(iframe);
        });
    };
    EmbedClientEx.prototype.abortableCreateSignedUrl = function (_a) {
        var _this = this;
        var waitUntilLoaded = _a.waitUntilLoaded, signal = _a.signal;
        return new Promise(function (resolve, reject) {
            var promiseAborted = false;
            var abortHandler = function () {
                _this._sdk._createEmbedSessionPromise = undefined;
                promiseAborted = true;
                reject(signal === null || signal === void 0 ? void 0 : signal.reason);
            };
            if (waitUntilLoaded && signal) {
                signal.addEventListener('abort', abortHandler);
            }
            _this.createSignedUrl()
                .then(function (url) {
                signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', abortHandler);
                if (!promiseAborted) {
                    resolve(url);
                }
            })
                .catch(function (error) {
                signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', abortHandler);
                if (!promiseAborted) {
                    _this._sdk._createEmbedSessionPromise = undefined;
                    reject(error);
                }
            });
        });
    };
    EmbedClientEx.prototype.createSignedUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
            var src, auth, url, _i, _a, param;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        src = this.appendRequiredParameters(this._builder.embedUrl);
                        // If the session exists there is no need to go though
                        // the signing process again so the naked url is used
                        // (prepended by the host).
                        if (this._sdk._sessionCreated) {
                            return [2 /*return*/, Promise.resolve(this.prependApiHost(src))];
                        }
                        if (!this._sdk._createEmbedSessionPromise) return [3 /*break*/, 2];
                        // Wait for the session to be created and then use
                        // the naked url prepended by the host
                        return [4 /*yield*/, this._sdk._createEmbedSessionPromise];
                    case 1:
                        // Wait for the session to be created and then use
                        // the naked url prepended by the host
                        _b.sent();
                        return [2 /*return*/, Promise.resolve(this.prependApiHost(src))];
                    case 2:
                        // Create the session acquire promise and make the resolve
                        // available. The promise will be resolved once the IFRAME
                        // has been created. The auth promise cannot be used as all
                        // it does is create the embed login url. The session does
                        // not exist until the IFRAME is loaded.
                        this._sdk._createEmbedSessionPromise = new Promise(function (resolve) {
                            _this._sdk._createEmbedSessionPromiseResolver = resolve;
                        });
                        auth = this._builder.auth;
                        url = "".concat(auth.url, "?src=").concat(encodeURIComponent(src));
                        if (auth.params) {
                            for (_i = 0, _a = auth.params; _i < _a.length; _i++) {
                                param = _a[_i];
                                url += "&".concat(encodeURIComponent(param.name), "=").concat(encodeURIComponent(param.value));
                            }
                        }
                        // eslint-disable-next-line no-async-promise-executor
                        return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                var xhr, _i, _a, header;
                                return __generator(this, function (_b) {
                                    xhr = new XMLHttpRequest();
                                    xhr.open('GET', url);
                                    if (auth.withCredentials) {
                                        xhr.withCredentials = auth.withCredentials;
                                    }
                                    xhr.setRequestHeader('Cache-Control', 'no-cache');
                                    if (auth.headers) {
                                        for (_i = 0, _a = auth.headers; _i < _a.length; _i++) {
                                            header = _a[_i];
                                            xhr.setRequestHeader(header.name, header.value);
                                        }
                                    }
                                    xhr.onload = function () {
                                        if (xhr.status === 200) {
                                            resolve(JSON.parse(xhr.responseText).url);
                                        }
                                        else {
                                            reject(xhr.statusText);
                                        }
                                    };
                                    xhr.onerror = function () { return reject(xhr.statusText); };
                                    xhr.send();
                                    return [2 /*return*/];
                                });
                            }); })];
                }
            });
        });
    };
    EmbedClientEx.prototype.acquireCookielessEmbedSession = function (options) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this._sdk._sessionCreated) {
                            if ((_a = this._sdk._cookielessSession) === null || _a === void 0 ? void 0 : _a.cookielessNavigationToken) {
                                return [2 /*return*/, this.getCookielessEmbedUrl()];
                            }
                            return [2 /*return*/, this.abortableAcquireCookielessEmbedSessionInternal(options)];
                        }
                        if (!this._sdk._createEmbedSessionPromise) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._sdk._createEmbedSessionPromise];
                    case 1:
                        _c.sent();
                        if ((_b = this._sdk._cookielessSession) === null || _b === void 0 ? void 0 : _b.cookielessNavigationToken) {
                            return [2 /*return*/, this.getCookielessEmbedUrl()];
                        }
                        return [2 /*return*/, this.abortableAcquireCookielessEmbedSessionInternal(options)];
                    case 2:
                        // Create the session acquire promise and make the resolve
                        // available. The promise will be resolved once the IFRAME
                        // has been created. The auth promise cannot be used as all
                        // it does is create the embed login url. The session does
                        // not exist until the IFRAME is loaded.
                        this._sdk._createEmbedSessionPromise = new Promise(function (resolve) {
                            _this._sdk._createEmbedSessionPromiseResolver = resolve;
                        });
                        return [2 /*return*/, this.abortableAcquireCookielessEmbedSessionInternal(options)];
                }
            });
        });
    };
    EmbedClientEx.prototype.abortableAcquireCookielessEmbedSessionInternal = function (_a) {
        var _this = this;
        var waitUntilLoaded = _a.waitUntilLoaded, signal = _a.signal;
        return new Promise(function (resolve, reject) {
            var promiseAborted = false;
            var abortHandler = function () {
                _this._sdk._createEmbedSessionPromise = undefined;
                promiseAborted = true;
                reject(signal === null || signal === void 0 ? void 0 : signal.reason);
            };
            if (waitUntilLoaded && signal) {
                signal.addEventListener('abort', abortHandler);
            }
            _this.acquireCookielessEmbedSessionInternal()
                .then(function (url) {
                signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', abortHandler);
                if (!promiseAborted) {
                    _this._sdk._sessionCreated = true;
                    resolve(url);
                }
            })
                .catch(function (error) {
                signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', abortHandler);
                if (!promiseAborted) {
                    _this._sdk._createEmbedSessionPromise = undefined;
                    reject(error);
                }
            });
        });
    };
    EmbedClientEx.prototype.acquireCookielessEmbedSessionInternal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tokens, authentication_token, api_token, api_token_ttl, navigation_token, navigation_token_ttl, session_reference_token_ttl, cookielessSession, apiHost, src, embedPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.acquireSession()];
                    case 1:
                        tokens = _a.sent();
                        authentication_token = tokens.authentication_token, api_token = tokens.api_token, api_token_ttl = tokens.api_token_ttl, navigation_token = tokens.navigation_token, navigation_token_ttl = tokens.navigation_token_ttl, session_reference_token_ttl = tokens.session_reference_token_ttl;
                        if (!authentication_token ||
                            !navigation_token ||
                            typeof navigation_token_ttl !== 'number' ||
                            !api_token ||
                            typeof api_token_ttl !== 'number' ||
                            typeof session_reference_token_ttl !== 'number') {
                            throw new Error('failed to prepare cookieless embed session');
                        }
                        if (this._sdk._cookielessSession) {
                            cookielessSession = this._sdk._cookielessSession;
                            cookielessSession.cookielessApiToken = api_token;
                            cookielessSession.cookielessApiTokenTtl = api_token_ttl;
                            cookielessSession.cookielessNavigationToken = navigation_token;
                            cookielessSession.cookielessNavigationTokenTtl = navigation_token_ttl;
                            cookielessSession.cookielessSessionReferenceTokenTtl =
                                session_reference_token_ttl;
                        }
                        apiHost = "https://".concat(this._builder.apiHost);
                        src = "".concat(this.appendRequiredParameters(this._builder.embedUrl), "&embed_navigation_token=").concat(navigation_token);
                        embedPath = '/login/embed/' +
                            encodeURIComponent(src) +
                            "?embed_authentication_token=".concat(authentication_token);
                        return [2 /*return*/, "".concat(apiHost).concat(embedPath)];
                }
            });
        });
    };
    EmbedClientEx.prototype.getCookielessEmbedUrl = function () {
        var _a;
        var apiHost = "https://".concat(this._builder.apiHost);
        var embedPath = "".concat(this.appendRequiredParameters(this._builder.embedUrl), "&embed_navigation_token=").concat(((_a = this._sdk._cookielessSession) === null || _a === void 0 ? void 0 : _a.cookielessNavigationToken) || '');
        return "".concat(apiHost).concat(embedPath);
    };
    EmbedClientEx.prototype.acquireSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var acquireSession, _a, url, init, resp, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        acquireSession = this._builder.acquireSession;
                        if (!(typeof acquireSession === 'function')) return [3 /*break*/, 2];
                        return [4 /*yield*/, acquireSession()];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2:
                        _b.trys.push([2, 5, , 6]);
                        _a = this.getResource(acquireSession), url = _a.url, init = _a.init;
                        return [4 /*yield*/, fetch(url, init)];
                    case 3:
                        resp = _b.sent();
                        if (!resp.ok) {
                            console.error('acquire embed session failed', { resp: resp });
                            throw new Error("acquire embed session failed");
                        }
                        return [4 /*yield*/, resp.json()];
                    case 4: return [2 /*return*/, (_b.sent())];
                    case 5:
                        error_2 = _b.sent();
                        console.error(error_2);
                        throw new Error("acquire embed session failed");
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    EmbedClientEx.prototype.generateTokens = function () {
        if (this._sdk._generateTokensPromise) {
            return this._sdk._generateTokensPromise;
        }
        if (!this._sdk._cookielessSession) {
            // This should never happen. Added to make typescript happy
            throw new Error('Invalid state. generateTokens called but cookielessSession not present');
        }
        var _a = this._sdk._cookielessSession, cookielessApiToken = _a.cookielessApiToken, cookielessApiTokenTtl = _a.cookielessApiTokenTtl, cookielessNavigationToken = _a.cookielessNavigationToken, cookielessNavigationTokenTtl = _a.cookielessNavigationTokenTtl, cookielessSessionReferenceTokenTtl = _a.cookielessSessionReferenceTokenTtl;
        var generateTokens = this._builder.generateTokens;
        if (typeof generateTokens === 'function') {
            this._sdk._generateTokensPromise = generateTokens({
                api_token: cookielessApiToken,
                api_token_ttl: cookielessApiTokenTtl,
                navigation_token: cookielessNavigationToken,
                navigation_token_ttl: cookielessNavigationTokenTtl,
                session_reference_token_ttl: cookielessSessionReferenceTokenTtl,
            });
            return this._sdk._generateTokensPromise;
        }
        var _b = this.getResource(generateTokens), url = _b.url, defaultInit = _b.init;
        var init = defaultInit
            ? __assign(__assign({ headers: {
                    'content-type': 'application/json',
                }, method: 'PUT' }, defaultInit), { body: JSON.stringify({
                    api_token: cookielessApiToken,
                    navigation_token: cookielessNavigationToken,
                }) }) : {
            body: JSON.stringify({
                api_token: cookielessApiToken,
                navigation_token: cookielessNavigationToken,
            }),
            headers: {
                'content-type': 'application/json',
            },
            method: 'PUT',
        };
        this._sdk._generateTokensPromise = fetch(url, init).then(function (resp) {
            if (resp.ok) {
                return resp.json();
            }
            else {
                throw new Error('Failed to generate tokens');
            }
        });
        return this._sdk._generateTokensPromise;
    };
    EmbedClientEx.prototype.getResource = function (resource) {
        var url;
        var init;
        if (typeof resource === 'object') {
            var tempUrl = resource.url, rest = __rest(resource, ["url"]);
            init = rest;
            url = tempUrl;
        }
        else {
            url = resource;
        }
        return { init: init, url: url };
    };
    EmbedClientEx.prototype.identifyPageType = function (event) {
        var _a;
        if (this._connection) {
            this._connection._pageType = (0, utils_1.extractPageTypeFromUrl)(((_a = event === null || event === void 0 ? void 0 : event.page) === null || _a === void 0 ? void 0 : _a.url) || '');
        }
    };
    EmbedClientEx.prototype.parseLookerVersion = function (lookerVersion) {
        if (lookerVersion && typeof this._lookerVersion !== 'number') {
            var _a = lookerVersion.split('.'), majorVersionString = _a[0], minorVersionString = _a[1];
            var version = parseFloat("".concat(majorVersionString, ".").concat(minorVersionString));
            if (!Number.isNaN(version)) {
                this._lookerVersion = version;
            }
        }
    };
    return EmbedClientEx;
}());
exports.EmbedClientEx = EmbedClientEx;
//# sourceMappingURL=EmbedClientEx.js.map